import React, { Component } from 'react';
import { Progress as OriginProgressBar } from "@tinper/next-ui";
require('./index.less');

export default class ProgressBar extends Component {
    render() {
        let { percent, now, className, ...others } = this.props;
        return <OriginProgressBar percent={percent || now} className={`${className || ''} base-nc-progress`} {...others} />;
    }
}
